import "../../../styles/page/shoppingCart.scss";


import { SubMenu, SubMenuItem } from "./SubMenu.jsx";

import Modal from "./Modal";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "./ResponsiveColumn";
import ResponsiveRows from "./ResponsiveRows";

import {iconTypes} from "./Icon.jsx";
import moment from "moment";

export default class AskMoveUnconfirmedLinesModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onMoveToNextOrder = this.onMoveToNextOrder.bind(this);
        this.onDeleteOrder = this.onDeleteOrder.bind(this);
    }

    onDeleteOrder() {        
        this.props.moveUnconfirmedLinesToNextOrder(true);
        this.props.onCloseModal();
    }

    onMoveToNextOrder() {
        this.props.moveUnconfirmedLinesToNextOrder(false);
        this.props.onCloseModal();
    }

    render() {
        const {
            localization, 
            oldUnconfirmedOrderLineCount,
            deliveryDates,
            orderLocked,
            onCloseModal,
        } = this.props;
        
        const nextDeliveryDate =  deliveryDates && deliveryDates.length>1 ? (orderLocked ? deliveryDates[1] : deliveryDates[0]) : null;

        return (            
            <Modal onCloseModal={onCloseModal} width={347}>
                <div className="order-ask-modal-header">
                    <SubMenu>
                        <SubMenuItem interactive={false} iconType={iconTypes.boxQuestion}></SubMenuItem>
                        <SubMenuItem side="left-borderless" interactive={false}>
                            <div className="label18 flex-align-center" style={{height:"100%", paddingLeft:"8px"}}>
                                {localization.text("order", orderLocked ? "orderLocked" : "oldLinesExists")}
                            </div>
                        </SubMenuItem>
                        <SubMenuItem side="locked-right" iconType={iconTypes.x} onClick={onCloseModal}></SubMenuItem>
                    </SubMenu>
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12}>
                            <div className="label16">
                                {localization.text("order", orderLocked ? "youHaveUnconfirmedOrderLines" : "youHaveOldUnconfirmedOrderLines",{count:oldUnconfirmedOrderLineCount})}
                            </div>
                            <div className="label16">
                                {localization.text("order","wantToMoveThem")}
                                ({<label style={{fontWeight:500,color:"#1e2f5a"}}>{moment(nextDeliveryDate && nextDeliveryDate.deliveryDate).format("MMM DD")}</label>})?
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12}>
                            <button className="btn primary" onClick={this.onMoveToNextOrder}>Ja</button>
                            <button className="btn" onClick={this.onDeleteOrder}>Nei</button>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </Modal>
        );
    }
}

AskMoveUnconfirmedLinesModal.propTypes = {
    localization: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    orderLocked: PropTypes.bool.isRequired,
    moveUnconfirmedLinesToNextOrder:  PropTypes.func.isRequired,
    oldUnconfirmedOrderLineCount: PropTypes.number.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    onCloseModal: PropTypes.func.isRequired,
};